import { SET, RESET_STATE } from "@/stores/CommumActionTypes";

const actions = {
	[SET]: ({ commit }, windMonitoringElementsTree) =>
	{
		commit(SET, windMonitoringElementsTree);
	},
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
};

export default { actions };